import React, { useCallback, useContext, useMemo } from "react";
import { FilterShowcase } from "../../../../../../Components/FilterShowcase/filterShowcase.index";
import { UserContext, UserPayload } from "../../../../../../Context/userContext";
import { AgentsFilters } from "../../../../agents.model";
import { DEFAULT_AGENTS_FILTERS } from "../../../../agents.constants";
import { useAgentsStore } from "../../../../store/agents.store";
import { selectFilters } from "../../../../store/agentsSelectors";
import { buildAgentsFilterChips } from "./agentsFilterShowcase.utils";

export const AgentsFilterShowcase = () => {
    const { setShowLoader } = useContext(UserContext) as UserPayload;
    const filters = useAgentsStore(selectFilters);
    const setFilters = useAgentsStore((state) => state.setFilters);
    const fetchAllAgents = useAgentsStore((state) => state.fetchAllAgents);

    const chips = useMemo(
        () => buildAgentsFilterChips(filters),
        [filters]
    );

    const applyFilters = useCallback(
        async (newFilters: AgentsFilters) => {
            setFilters(newFilters);
            await fetchAllAgents({ setShowLoader, force: true });
        },
        [setFilters, fetchAllAgents, setShowLoader]
    );

    const handleClearAllFilters = async () => {
        await applyFilters(DEFAULT_AGENTS_FILTERS);
    };

    const handleRemove = async (key: keyof AgentsFilters) => {
        await applyFilters({
            ...filters,
            [key]: [],
        });
    };

    return (
        <FilterShowcase
            chips={chips}
            onRemove={handleRemove}
            onClearAll={handleClearAllFilters}
        />
    );
};
